import React from 'react';

type Props = {
    title: string;
};

const SiteNav: React.FC<Props> = ({ title }: Props) => {
    return (
        <div className="h-site-nav w-full bg-calcite-background-black text-white">
            <div className="container h-full flex items-center">
                <div className="">
                    <span className="text-2xl font-light">{title}</span>
                </div>
            </div>
        </div>
    );
};

export default SiteNav;
